import React, {useEffect, useState} from 'react';
import {
    Grid,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
    Button,
} from '@material-ui/core';
import {
    MyAccordion,
    MyAccordionSummary,
    MyAccordionDetails,
} from '../Accordions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {NavLink} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import {H6} from 'components/TypographyShortcuts';
import InfoModal from 'components/widgets/tooltips/InfoModal';
import {usePutApplicationChecklist} from 'hooks';
import sectionContent from 'components/widgets/checklists/ChecklistSectionContent';

const useStyles = makeStyles(theme => ({
    root: {
        [theme.breakpoints.down('sm')]: {
            width: '20em',
            height: '15em',
        },
        [theme.breakpoints.up('md')]: {
            width: '40em',
            height: '30em',
        },
    },
    accordion: {
        justifyContent: 'stretch',
        background: theme.palette.gray.light,
        '&.complete': {
            background: theme.palette.type === 'dark' ? theme.palette.success.dark : theme.palette.success.light,
        }
    },
    summary: {
        background: theme.palette.gray.light,
        '&.complete': {
            background: theme.palette.type === 'dark' ? theme.palette.success.dark : theme.palette.success.light,
        }
    },
    checkbox: {
        color: theme.palette.primary.main,
    }
}));

const ChecklistSection = ({sectionId, checkoffs, complete, setComplete}) => {
    const classes = useStyles();
    const {put: putApplication, result} = usePutApplicationChecklist();
    const {
        labelId,
        title,
        description,
        secondaryDescription,
        link,
        link_text,
        fields,
        infoModalContent,
    } = sectionContent?.[sectionId];

    const pruneData = sourceOfTruth =>
        fields.reduce((object, item) => {
            return {
                ...object,
                [item]: sourceOfTruth?.application_checklist[item] || false,
            };
        }, {});
    const sourceOfTruth = result || checkoffs;
    const [prunedData, setPrunedData] = useState(pruneData(sourceOfTruth));
    
    const handleChange = value => {
        const newData = {
            ...prunedData,
            [value]: !prunedData[value],
        };
        setPrunedData(newData);
        putApplication(newData);
    };

    useEffect(() => {
        if (result) {
            const thisSectionComplete =
                result?.application_checklist?.[labelId];
            setComplete(thisSectionComplete);
        } else {
            const thisSectionComplete =
                checkoffs?.application_checklist?.[labelId];
            setComplete(thisSectionComplete);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkoffs, result]);

    // Handle the POST updates in case a checkbox isn't allowed to be checked
    useEffect(() => {
        if (result || checkoffs) {
            setPrunedData(pruneData(sourceOfTruth));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkoffs, result, sourceOfTruth]);

    return (
        <MyAccordion className={`${classes.accordion} ${complete ? 'complete' : ''}`}>
            <MyAccordionSummary
                className={`${classes.summary} ${complete ? 'complete' : ''}`}
                expandIcon={<ExpandMoreIcon />}
            >
                <Grid container className={classes.titleContainer}>
                    <Grid
                        item
                        style={{
                            display: 'flex',
                            justifyContent: 'left',
                        }}
                        xs={12}
                    >
                        {title ? (
                            <H6>
                                <strong>{title}</strong>
                            </H6>
                        ) : null}
                        <InfoModal content={infoModalContent} />
                    </Grid>
                </Grid>
            </MyAccordionSummary>
            <MyAccordionDetails className={`${classes.summary} ${complete ? 'complete' : ''}`}>
                <ListItem key={labelId} role='button' dense button>
                    <ListItemIcon
                        onClick={() => {
                            handleChange(labelId);
                        }}
                        style={{alignSelf: 'flex-start'}}
                    >
                        <Checkbox
                            className={classes.checkbox}
                            edge='start'
                            checked={prunedData[labelId]}
                            disableRipple
                            inputProps={{
                                'aria-labelledby': labelId,
                            }}
                        />
                    </ListItemIcon>

                    <Grid container direction='column'>
                        {description || secondaryDescription ? (
                            <Grid item>
                                <ListItemText
                                    //id={labelId}
                                    primary={description}
                                    secondary={secondaryDescription}
                                />
                            </Grid>
                        ) : null}
                        {link ? (
                            <Grid item>
                                <Button
                                    component={NavLink}
                                    to={link}
                                    variant='contained'
                                    color='secondary'
                                    style={{width: 'fit-content'}}
                                >
                                    {link_text}
                                </Button>
                            </Grid>
                        ) : null}
                    </Grid>
                </ListItem>
            </MyAccordionDetails>
        </MyAccordion>
    );
};
export default ChecklistSection;
